export { default } from './[index]';
